import React from 'react';
import PropTypes from 'prop-types';
import {Chip, Tooltip} from '@mui/material';
import {CheckCircle as CheckCircleIcon} from '@mui/icons-material';

const ApiSuccessChip = ({integration_source, api_credential_id}) => {
  // Show the chip if there's an integration source and API credential ID
  const showChip = integration_source && api_credential_id;

  if (!showChip) {
    return null;
  }

  return (
    <Tooltip
      title={`Successfully entered from ${integration_source} API`}
      arrow
    >
      <Chip
        icon={<CheckCircleIcon />}
        label='API Success'
        size='small'
        variant='filled'
        sx={{
          backgroundColor: '#e8f5e8',
          color: '#2e7d32',
          border: '1px solid #4caf50',
          fontSize: '0.7rem',
          height: '22px',
          '& .MuiChip-icon': {
            fontSize: '14px',
          },
        }}
      />
    </Tooltip>
  );
};

ApiSuccessChip.propTypes = {
  integration_source: PropTypes.string,
  api_credential_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ApiSuccessChip;
